import { render, staticRenderFns } from "./AdminRaw.vue?vue&type=template&id=6385e244&"
import script from "./AdminRaw.vue?vue&type=script&lang=js&"
export * from "./AdminRaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports